module.exports = __webpack_public_path__ + "static/media/apm-hand.dffc35d6.jpg";